import { plaintextValidator } from '../fields';

const config = { mandatory: true };

export default {
  clientId: plaintextValidator(config),
  clientSecret: plaintextValidator(config)
};
